/**
 * Created by Claude on 07.02.2026
 */

const GeneratorMultiplierIcon = function (row) {
    const config = bundles.generator_multiplier_icon.jsons.generatormultipliericon_prefab_json;
    return Prefab.instantiate(config, { row });
};
